module.exports = __webpack_public_path__ + "img/icon-dangerous-goods-text.369241c7.svg";